// export const itemUrl = 'http://127.0.0.1:8000/machinery-items/'
// export const fillUrl = 'http://127.0.0.1:8000/api/item/fill/'


// export const itemUrl = '/api/machinery-item/'

// Заполнение значениями для еденицы техники (редактирование)
// export const fillUrl = '/api/machinery-item/fill/'


export const searchUrl = '/api/type/search/'

